/**
 * Shared rules of the government letter pages and the Sales Invoice (no React, no database).
 */

const pad = (n) => String(n).padStart(2, '0');

/** Today as "yyyy-mm-dd" in the user's own day (toISOString gave yesterday before 04:00 in Dubai). */
export const todayIso = (now = new Date()) => `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;

/**
 * The form as saved in this browser, over the page's defaults - but the date always starts as
 * today's (the default): each page saves its whole form, so a letter opened on 26/09 used to
 * print the date typed the last time (e.g. 10/08) unless someone noticed (audit FLT-13).
 */
export const restoreSavedForm = (savedJson, initial) => {
    if (!savedJson) return initial;
    try {
        const parsed = JSON.parse(savedJson);
        return { ...initial, ...(parsed && parsed.formData), date: initial.date };
    } catch (e) {
        return initial;
    }
};

/** One invoice row's total; an empty amount or VAT counts as 0 (as in the totals and the PDF). */
export const invoiceRowTotal = (car) => (parseFloat(car?.sale_amount) || 0) + (parseFloat(car?.sale_vat) || 0);

/**
 * Where a captured page goes on the A4 sheet (mm): full width, or scaled down to fit the height
 * when the page came out taller than A4, centred across. Each page is captured on its own
 * canvas: one tall canvas cut into equal slices cut through rows when pages had different
 * heights (audit FLT-17).
 */
export const fitOnPage = (imgWidth, imgHeight, pageWidth, pageHeight) => {
    let width = pageWidth;
    let height = imgWidth > 0 ? (imgHeight * pageWidth) / imgWidth : pageHeight;
    if (height > pageHeight) {
        width = (width * pageHeight) / height;
        height = pageHeight;
    }
    return { x: (pageWidth - width) / 2, y: 0, width, height };
};
